export const environment = {
  production: true,
  appSettingsFile:'app.prod.settings.json',
  projectNameEbld: 'e-belediye'
  // baseUrl: 'https://kamudata.dabto.com/',
  // kamuService: 'https://kamuservices.dabto.com/',
  // lookupService: 'https://ortservices.dabto.com/',
  // reportService: 'https://kamureports.dabto.com/',
  // tebService:'https://tebservices.dabto.com/',
  // temService:'https://temservices.dabto.com/',
  // genService: 'https://genservices.dabto.com/',
  // ortakService:'https://ortservices.dabto.com/',
  // bysService:'https://bysservices.dabto.com/',
  // identityConfig: {
  //   authority: 'https://dabid.dabto.com',
  //   client_id: 'App2Client',
  //   redirect_uri: 'https://app2.dabto.com/callback',
  //   response_type: 'code',
  //   response_mode: 'query',
  //   loadUserInfo: true,
  //   scope: 'skoruba_identity_admin_api openid profile roles email address',
  //   post_logout_redirect_uri: 'https://app2.dabto.com/logout',
  //   automaticSilentRenew: true,
  //   silent_redirect_uri: 'https://app2.dabto.com/refreshtoken',
  //   automaticRedirectAfterSignOut: true,
  //   silentRequestTimeout: 10000000,
  //   extraQueryParams: {
  //     logo_uri:
  //       'https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/angular/angular.png',
  //   },
  // },
};
